// SPDX-License-Identifier: AGPL-3.0-or-later

import * as Modal from '@app/features/app/components/dialogs/Modal';
import {TextualAttachmentCodePanel} from '@app/features/channel/components/embeds/attachments/TextualAttachmentCodePanel';
import styles from '@app/features/channel/components/embeds/attachments/TextualAttachmentPreview.module.css';
import {TextualAttachmentPreviewFooter} from '@app/features/channel/components/embeds/attachments/TextualAttachmentPreviewFooter';
import {
	getLineCount,
	type TextualAttachmentPreviewModalProps,
} from '@app/features/channel/components/embeds/attachments/TextualAttachmentPreviewUtils';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import {useMemo} from 'react';
export const TextualAttachmentPreviewModal = observer(function TextualAttachmentPreviewModal({
	attachment,
	highlightedHtml,
	inferredLanguageCode,
	onClose,
	onMoreOptions,
	onSelectLanguage,
	previewError,
	selectedLanguage,
	status,
	textContent,
	wrapText,
}: TextualAttachmentPreviewModalProps) {
	const {i18n} = useLingui();
	const lineCount = useMemo(() => getLineCount(textContent), [textContent]);
	const visibleLineCount = useMemo(() => Math.max(lineCount, 1), [lineCount]);
	return (
		<Modal.Root size="fullscreen" onClose={onClose} className={styles.modalRoot}>
			<Modal.ScreenReaderLabel text={i18n._(msg`Attachment preview`)} />
			<div className={styles.modalLayout}>
				<div className={styles.modalBody}>
					<TextualAttachmentCodePanel
						canExpand
						fillAvailableSpace
						highlightedHtml={highlightedHtml}
						isExpanded
						previewError={previewError}
						status={status}
						textContent={textContent}
						visibleLineCount={visibleLineCount}
						wrapText={wrapText}
						wrapperClassName={styles.modalPreviewSurface}
					/>
				</div>
				<TextualAttachmentPreviewFooter
					attachment={attachment}
					canExpand={false}
					inferredLanguageCode={inferredLanguageCode}
					isExpanded
					lineCount={lineCount}
					onMoreOptions={onMoreOptions}
					onSelectLanguage={onSelectLanguage}
					selectedLanguage={selectedLanguage}
					showExpandButton={false}
				/>
			</div>
		</Modal.Root>
	);
});
